import axiosClient from '@/config/api/axios'
import { INTEGRATION_CONNECTIONS } from '@/config/api/endpoints'
import { toolPermissionsSchema } from '@/schemas/integrations/toolPermissions'

const path = (connectionId) => `${INTEGRATION_CONNECTIONS}/${encodeURIComponent(connectionId)}`

export async function fetchToolPermissions({ connectionId, signal }) {
  const { data } = await axiosClient.get(`${path(connectionId)}/tools`, { signal })
  return toolPermissionsSchema.parse(data)
}

export async function saveToolPermissions({ connectionId, expectedRevision, tools }) {
  const { data } = await axiosClient.put(`${path(connectionId)}/permissions`, {
    expected_revision: expectedRevision, tools,
  })
  return toolPermissionsSchema.parse(data)
}
